<template>
  <div class="wrapper">
    <the-container class="main">
      <slot />
    </the-container>
  </div>
</template>

<script>
import TheContainer from '@/components/my-page-partials/TheContainer.vue'

export default {
  components: { TheContainer },
}
</script>

<style lang="scss">
@import '@/assets/css/layouts/mypage-layout.scss';
</style>
